var React = require('react');

function Xicon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .x-icon-svg {\n        fill: #d1d1d1;\n      }\n    ")),React.createElement("path",{"id":"Rounded_Rectangle_11_copy_3","data-name":"Rounded Rectangle 11 copy 3","className":"x-icon-svg","d":"M657.464,225.464a1,1,0,0,1,1.415,0l5.656,5.657a1,1,0,0,1-1.414,1.414l-5.657-5.656A1,1,0,0,1,657.464,225.464Zm7.246-.175a1.044,1.044,0,0,1,0,1.478l-5.91,5.911a1.045,1.045,0,1,1-1.478-1.478l5.911-5.911A1.044,1.044,0,0,1,664.71,225.289Z","transform":"translate(-657.031 -225)","key":1})]);
}

Xicon.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8"};

module.exports = Xicon;

Xicon.default = Xicon;
